import { getResampleReliability } from '@/libs/utils'

export function checkSampling (domain, basicInfo, originJourneyData, resultData) {
  const originSamplingRate = domain.samplingRate || 1
  const sampleCount = basicInfo.resample.session // result.sessCnt
  const originCount = basicInfo.resample.totalSessCount // result.totalSessCount // this.basicInfo[this.journeyOptions.device]
  const sessionSamplingRate = domain.samplingRate / 100
  const resampleCount = sampleCount / (originSamplingRate / 100)

  console.log(`origin: ${originCount}, sample: ${sampleCount}, resample: ${resampleCount}, rate : ${sessionSamplingRate}`)

  const reliability = getResampleReliability(originCount, resampleCount)

  if (sampleCount <= 0 || resampleCount <= 0) {
    return false
    // EventBus.$emit('loadPaneNoData', true, true)
  }

  const origin = {
    ...originJourneyData,
    resampleCount: resampleCount,
    originSamplingRate,
    sessionSamplingRate: sessionSamplingRate > 0 ? sessionSamplingRate : originSamplingRate,
    reliability: reliability
  }
  if (resultData) {
    origin.totalSessCount = resultData.totalSessCount
  }

  return origin
}
